import { useEffect, useState } from "react";
import * as AppConstants from "AppConstants";
import { checkUserHasMemberRole, getCurrentMember } from "app/services/app.state.service";
import { ConsolidatedReportFilter } from "../reports/ConsolidatedReportFilter";
import { HolidayListView } from "app/components/leave-plans/HolidayListView";
import { Alert, Grid, Snackbar } from "@mui/material";

export const MemberDashboard = () => {
  const [profileMissing, setProfileMissing] = useState(false);

  useEffect(() => {
    if (!checkUserHasMemberRole()) return;
    getCurrentMember()
      .then((member) => {
        if (!member || !member.id) setProfileMissing(true);
      })
      .catch(() => setProfileMissing(true));
  }, []);

  if (!checkUserHasMemberRole()) {
    return <div>You do not have access to this functionality.</div>;
  }

  return (
    <div className="content-container" style={{width: "100%" }}>
      <Grid container spacing={6}>
        <Grid size={12}>
          <Grid size={12}>
            <ConsolidatedReportFilter role={AppConstants.ROLE_EMPLOYEE_MEMBER} />
          </Grid>
        </Grid>
        <Grid size={12}>
          <HolidayListView />
        </Grid>
      </Grid>
      <Snackbar
        open={profileMissing}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={8000}
        onClose={() => setProfileMissing(false)}
      >
        <Alert
          severity="warning"
          variant="filled"
          onClose={() => setProfileMissing(false)}
          sx={{ width: "100%" }}
        >
          Account setup incomplete. Please contact your administrator to link your profile.
        </Alert>
      </Snackbar>
    </div>
  );
};
